import { all, takeEvery, put, select, call, fork } from 'redux-saga/effects'
import actionTypes from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'

export default function* orderSaga() {
  yield all([fork(watchSetOrder), fork(watchPostOrderRequest)])
}

export function* watchSetOrder() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS_SET_ORDER, handleSetOrder)
}

export function* handleSetOrder() {
  const list = yield select(selectors.getListForUpdateOrder)
  yield put(actions.orgInactiveNotifications.postOrder.request(list))
}

export function* watchPostOrderRequest() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.POST_ORDER.REQUEST, handlePostOrderRequest)
}

export function* handlePostOrderRequest({ payload: { data: list } }) {
  try {
    const pending = yield select(selectors.getPendingPostOrder)
    if (!pending) {
      yield put(actions.setPending('postOrder', true))
      const orgId = yield select(getViewOrganizationSettingsId)
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/set-order`, {
        method: 'POST',
        data: {
          orders: list.toJS(),
        },
      })
      yield put(actions.orgInactiveNotifications.postOrder.success(list))
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.postOrder.fail(error))
  }
}
